"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const ActionTypes = require("../../actionTypes/auth/forgotPassword");
exports.initialState = {
    email: '',
    recaptchaCode: '',
    status: 'STANDBY',
    validationError: null
};
const emailLens = monocle.Lens.fromProp('email');
const recaptchaCodeLens = monocle.Lens.fromProp('recaptchaCode');
const statusLens = monocle.Lens.fromProp('status');
const validationErrorLens = monocle.Lens.fromProp('validationError');
exports.methods = {};
exports.methods[ActionTypes.SET_FORGOT_PASSWORD_EMAIL] = (state, action) => emailLens.set(action.payload)(state);
exports.methods[ActionTypes.SET_RECAPTCHA_CODE] = (state, action) => recaptchaCodeLens.set(action.payload)(state);
exports.methods[ActionTypes.RESET_FORGOT_PASSWORD_STATE] = () => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.SEND_FORGOT_PASSWORD_EMAIL_REQUEST] = (state) => statusLens.set('SENDING')(state);
exports.methods[ActionTypes.SEND_FORGOT_PASSWORD_EMAIL_SUCCESS] = (state) => statusLens.set('SENDED')(state);
exports.methods[ActionTypes.SEND_FORGOT_PASSWORD_EMAIL_FAILURE] = (state) => statusLens.set('FAILED')(state);
exports.methods[ActionTypes.SEND_FORGOT_PASSWORD_EMAIL_VALIDATION] = (state, action) => fp.function.compose(validationErrorLens.set('INVALID_EMAIL'), statusLens.set('FAILED'))(state);
//# sourceMappingURL=forgotPassword.js.map